import { Helmet } from "react-helmet";
import About from "../components/HomeComponents/About";
import Insight from "../components/HomeComponents/Insight";
import HomeStat from "../components/HomeComponents/HomeStat";
import PastRecruiter from "../components/HomeComponents/PastRecruiter";
import HomeStatSection from "../components/HomeComponents/HomeStatSection";
import { Card , Stat  } from './Styles';

export default function Home() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Home | Placementor</title>
        <link
          rel="icon"
          type="image/png"
          href="https://github.com/MejarKumar/All-Company-Logo/blob/main/favicon-32x32.png?raw=true"
        />
        <meta name="theme-color" content="#064420" />
      </Helmet>
      <About />
      <Insight />
      <HomeStat>
        <Card>
          <Stat>
            <p>Total Offers</p>
            <h3>920+</h3>
          </Stat>
          <Stat>
            <p>Companies Participated</p>
            <h3>200+</h3>
          </Stat>
          <Stat>
            <p>International Offers</p>
            <h3>15+</h3>
          </Stat>
        </Card>
      </HomeStat>
      <PastRecruiter />
      <HomeStatSection />
    </>
  );
}
